import { List, MenuItem, Stack, styled } from '@mui/material';
import Scrollbar from 'src/components/scrollbar';

export const HeaderIcon = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  width: 40,
  height: 40,
}));

export const NavScroolbar = styled(Scrollbar)(({ theme }) => ({
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  overflowY: 'auto',
  backgroundColor: theme.palette.background.default,
  '& .simplebar-content': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  '&.isAppCollaborate': {
    paddingTop: theme.spacing(2),
  },
}));

export const HeaderMoreItemsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1, 1.5),
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const NavRootList = styled(List)(({ theme }) => ({
  '&.MuiList-root': {
    padding: theme.spacing(0.25, 1.5, 1.5),
  },
}));

export const NavRootMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: theme.spacing(0.25, 2.5),
  gap: theme.spacing(0.5),
  '&:not(:last-child)': {
    marginBottom: 0,
  },
  '&.isTreeview': {
    paddingLeft: theme.spacing(3.75),
  },
}));
